import { getFullUrl, getReferer } from "./Utils";

export const sendEvent = (eventName, params={})=>{

  try{
    let clientId = ga.getAll()[0].get('clientId');
    let sessionId = 0;
    sessionId = clientId.split('.')[0];
    let page_referrer = getReferer() ? getReferer() : localStorage.getItem('urlReferer');

    let listEvents = {
      event : eventName,
      page_location: getFullUrl(),
      page_referrer: page_referrer,
      ga_client_id: clientId,
      ga_session_id: sessionId
    };

    const mergedObject = Object.assign({}, listEvents, params);

    dataLayer.push(mergedObject);
    
    let currentTime = new Date();
    // Extract hours, minutes, and seconds from the Date object
    let hours = currentTime.getHours();
    let minutes = currentTime.getMinutes();
    let seconds = currentTime.getSeconds();
    // Format the time as HH:MM:SS
    let formattedTime = hours + ":" + (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + seconds;

    // localStorage.setItem('analitycs_even|'+eventName+'|'+formattedTime, JSON.stringify(mergedObject));
    // console.log('analitycs_even|'+eventName+'|'+formattedTime, mergedObject);
  }catch(e){}
}